import * as Programs from "../../programs";
import processMap from "../../util/processMap";

const id = "__TEMPLATE__";
const map = `
AaBbCc--
123-#---
@@@-----
`;
const enemies = [Programs.Watchman, Programs.GuardPup, Programs.Sentinel];
const creditValues: number[] = [300, 340, 320];

const level = processMap(id, map, enemies, creditValues);

export default level;
